const birRequestConstants = {
  GET_ADMIN_BIR_REQUESTS: 'GET_ADMIN_BIR_REQUESTS',
  UPDATE_ADMIN_BIR_REQUEST: 'UPDATE_ADMIN_BIR_REQUEST',
  UPLOAD_ADMIN_BIR_REQUEST_FILE: 'UPLOAD_ADMIN_BIR_REQUEST_FILE',
  DELETE_ADMIN_BIR_REQUEST_FILE: 'DELETE_ADMIN_BIR_REQUEST_FILE'
};

export default birRequestConstants;
